import { render, staticRenderFns } from "./ControlKeyTable.vue?vue&type=template&id=59c09cea&scoped=true&"
import script from "./ControlKeyTable.vue?vue&type=script&lang=ts&"
export * from "./ControlKeyTable.vue?vue&type=script&lang=ts&"
import style0 from "./ControlKeyTable.vue?vue&type=style&index=0&id=59c09cea&scoped=true&lang=scss&"
import style1 from "./ControlKeyTable.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c09cea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardTitle,VSimpleTable,VSpacer})
